import styled from 'styled-components';
export var NavTitle = styled.span.withConfig({
  displayName: "NavTitle",
  componentId: "sc-l87ffq-0"
})(["position:relative;flex-shrink:0;padding:18px 18px 18px 8px;margin-right:15px;color:", ";&:after{position:absolute;top:18px;bottom:18px;right:0;border-right:1px solid ", ";content:'';}"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.font;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.borderColor;
});